import { z } from "zod";

export const updateVehiclePayloadSchema = z.object({
  uuid: z.uuid(),
  department: z.uuid().nullable().optional(),
  deviceLastActivityDate: z.iso.datetime().nullable().optional(),
});

export type UpdateVehiclePayload = z.infer<typeof updateVehiclePayloadSchema>;
